module.exports = __webpack_public_path__ + "static/media/development.43b185e4.png";